export default __webpack_public_path__ + "static/media/icon_intelligences.17f2f82d.png";